module.exports = require("marked");